import { Button, HStack, UI, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { FixedFeeNewContractStepOneData } from '../../types';

interface StepSuccessProps {
  stepOneData: FixedFeeNewContractStepOneData;
  onFollow: () => void;
}

export const StepSuccess: React.FC<StepSuccessProps> = ({ stepOneData, onFollow }) => {
  const infoItems = [
    { label: 'Serviço', value: 'Contrato de Feefixo' },
    { label: 'Identificador do contrato', value: stepOneData.contractIdentifier },
    { label: 'Taxa', value: Utils.Mask.Percentage(stepOneData.rate) },
    { label: 'Cliente', value: stepOneData.selectedCustomer?.customerNameNormalized || '--' },
    {
      label: 'Conta de custódia',
      value: stepOneData.selectedCustomer?.custodyAccountNormalized || '--',
    },
  ];

  const orderInfoItems = [
    { label: 'Canal de envio', value: stepOneData.sendingChannelsSelected.join(', ') || '--' },
    {
      label: 'Hora/data de Envio',
      value: Utils.Mask.DateFormat(new Date(), ' HH:mm:ss dd/MM/yyyy'),
    },
  ];

  return (
    <VStack space="stack.xxxs" flex={1}>
      <HStack
        borderRadius={BoxBorder.heavy}
        p="inset.nano"
        space="inline.quarck"
        bg={Utils.ColorToken.WithOpacity('neutral.lightest', 0.15)}
        alignItems="center">
        <UI.Icon name="Check" size="md" color="feedback.success.default" />
        <VStack maxW="90%" space="stack.quarck">
          <UI.Text variant="semibold">Solicitação enviada com sucesso!</UI.Text>
          <UI.Text>
            Você poderá acompanhar suas solicitações clicando no botão{' '}
            <UI.Text fontFamily={Typography['fontfamily.base.semibold']}>acompanhar</UI.Text>.
          </UI.Text>
        </VStack>
      </HStack>

      <VStack
        borderRadius={BoxBorder.heavy}
        px="inline.xxs"
        py="stack.xxxs"
        space="stack.nano"
        bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
        <UI.Text variant="semibold">Detalhes da solicitação</UI.Text>
        {infoItems.map((item) => (
          <HStack key={item.label} justifyContent="space-between" space="inline.quarck">
            <UI.Text>{item.label}</UI.Text>
            <UI.Text variant="semibold">{item.value}</UI.Text>
          </HStack>
        ))}
      </VStack>

      <VStack
        borderRadius={BoxBorder.heavy}
        px="inline.xxs"
        py="stack.xxxs"
        space="stack.nano"
        bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
        <UI.Text variant="semibold">Detalhes da ordem</UI.Text>
        {orderInfoItems.map((item) => (
          <HStack key={item.label} justifyContent="space-between" space="inline.quarck">
            <UI.Text>{item.label}</UI.Text>
            <UI.Text variant="semibold">{item.value}</UI.Text>
          </HStack>
        ))}
      </VStack>

      <Button onPress={onFollow} w="full">
        Acompanhar
      </Button>
    </VStack>
  );
};
